import { render, staticRenderFns } from "./display-delivery.vue?vue&type=template&id=0db04f31&scoped=true&"
import script from "./display-delivery.vue?vue&type=script&lang=js&"
export * from "./display-delivery.vue?vue&type=script&lang=js&"
import style0 from "./display-delivery.vue?vue&type=style&index=0&id=0db04f31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db04f31",
  null
  
)

export default component.exports